import { Type } from "@scalar/typebox";
import { AVAILABLE_CLIENTS } from "@scalar/types/snippetz";
import { compose } from "../schemas/compose.js";
import { extensions } from "../schemas/extensions.js";
import { xScalarClientConfigCookiesSchema } from "../schemas/v3.1/strict/client-config-extensions/x-scalar-client-config-cookies.js";
import { xScalarClientConfigEnvironmentsSchema } from "../schemas/v3.1/strict/client-config-extensions/x-scalar-client-config-environments.js";
import { OpenAPIDocumentSchema, SecuritySchemeObjectSchema, ServerObjectSchema } from "./v3.1/strict/openapi-document.js";
const WorkspaceDocumentMetaSchema = Type.Partial(
  Type.Object({
    [extensions.document.activeAuth]: Type.String(),
    [extensions.document.activeServer]: Type.String()
  })
);
const WorkspaceDocumentSchema = Type.Intersect([WorkspaceDocumentMetaSchema, OpenAPIDocumentSchema]);
const WorkspaceMetaSchema = Type.Partial(
  Type.Object({
    [extensions.workspace.darkMode]: Type.Boolean(),
    [extensions.workspace.defaultClient]: Type.Union(AVAILABLE_CLIENTS.map((client) => Type.Literal(client))),
    [extensions.workspace.activeDocument]: Type.String(),
    [extensions.workspace.theme]: Type.String()
  })
);
const WorkspaceExtensionsSchema = Type.Partial(
  Type.Object({
    "x-scalar-client-config-environments": xScalarClientConfigEnvironmentsSchema,
    "x-scalar-client-config-cookies": xScalarClientConfigCookiesSchema,
    "x-scalar-client-config-servers": Type.Array(ServerObjectSchema),
    "x-scalar-client-config-security-schemes": Type.Record(Type.String(), SecuritySchemeObjectSchema)
  })
);
const WorkspaceSchema = compose(
  WorkspaceMetaSchema,
  Type.Object({
    documents: Type.Record(Type.String(), WorkspaceDocumentSchema),
    /** Active document is possibly undefined if we attempt to lookup with an invalid key */
    activeDocument: Type.Union([Type.Undefined(), WorkspaceDocumentSchema])
  }),
  WorkspaceExtensionsSchema
);
export {
  WorkspaceDocumentMetaSchema,
  WorkspaceDocumentSchema,
  WorkspaceExtensionsSchema,
  WorkspaceMetaSchema,
  WorkspaceSchema
};
//# sourceMappingURL=workspace.js.map
